<div *ngIf="firstValidIndex !== -1">
    <!-- show the shortened text -->
    <ng-container *ngIf="!showFullText; else fullAbstract">
        <h2>{{ headers[firstValidIndex] | hisUi }}</h2>
        <!-- show the shortened text -->
        <div *ngIf="hisObjects[firstValidIndex] && hisAttribute">
            <his-translated-text [hisobject]="hisObjects[firstValidIndex]" [hisAttribute]="hisAttribute" [maxLength]="maxLength"></his-translated-text>
        </div>
    </ng-container>

    <!-- show text in full length -->
    <ng-template #fullAbstract>
        <div *ngFor="let header of headers; index as index;" class="description">
            <ng-container *ngIf="isEntryValid(hisObjects[index])">
                <h2>{{ header | hisUi }}</h2>
                <!-- show text in full length -->
                <div class="layoutBlock">
                    <div class="wordBreak columnDetailLabel fullWidth">
                        <his-translated-text *ngIf="index === firstValidIndex" [hisobject]="hisObjects[index]" [hisAttribute]="hisAttribute" />
                        <his-translated-html *ngIf="index !== firstValidIndex" [hisobject]="hisObjects[index]" [hisAttribute]="hisAttribute" />
                     </div>
                </div>
            </ng-container>
        </div>
    </ng-template>
    <ng-container *ngIf="showButtons">
        <button *ngIf="!showFullText" (click)="setShowFullText(true)" class="icon" hisImage="ARROW_DOWN_V" title="{{ expandToolTip | hisUi }}"></button>
        <button *ngIf="showFullText" (click)="setShowFullText(false)" class="icon" hisImage="ARROW_UP_V" title="{{ collapseToolTip | hisUi }}"></button>
    </ng-container>
</div>